module.exports = __webpack_public_path__ + "img/edit-tools.c1c30a01.svg";